module.exports = __webpack_public_path__ + "img/版本号.f6674ccf.png";